import { createContext, useState } from "react";
import DropdownBtn from "./DropdownBtn";
import DropdownMenu from "./DropdownMenu";
import DropdownMenuItem from "./DropdownMenuItem";
import DropdownDivider from "./DropdownDivider";
import DropdownHeader from "./DropdownHeader";

/**
 * @typedef {Object} CustomDropdownProps
 * @property {React.ReactNode} children
 */

/**
 * @param {CustomDropdownProps} param0
 * @returns {JSX.Element} Dropdown component
 */

export const DropdownContext = createContext({});

const Dropdown = ({ children }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <DropdownContext.Provider value={{ open, handleClick, handleClose, anchorEl }}>
      {children}
    </DropdownContext.Provider>
  );
};

Dropdown.Button = DropdownBtn;
Dropdown.Menu = DropdownMenu;
Dropdown.MenuItem = DropdownMenuItem;
Dropdown.Divider = DropdownDivider;
Dropdown.Header = DropdownHeader;

export default Dropdown;
